import { api } from "../../api/client.js";
import type { Asset, ReferenceItem } from "../../api/types.js";

export type AssetScopeInput = {
  projectId: string;
  sessionId?: string;
};

export async function createLinkAsset({
  projectId,
  sessionId,
  title,
  url,
  kind = "link"
}: AssetScopeInput & {
  title: string;
  url?: string;
  kind?: string;
}) {
  const data = await api<{ asset: Asset }>("/api/assets", {
    method: "POST",
    body: JSON.stringify({ projectId, sessionId, title, url, kind })
  });
  return data.asset;
}

export async function uploadAsset({
  projectId,
  sessionId,
  file
}: AssetScopeInput & {
  file: File;
}) {
  const formData = new FormData();
  formData.append("projectId", projectId);
  if (sessionId) formData.append("sessionId", sessionId);
  formData.append("title", file.name);
  formData.append("file", file);
  const data = await api<{ asset: Asset }>("/api/assets", {
    method: "POST",
    body: formData
  });
  return data.asset;
}

export async function saveSourceAsset({
  projectId,
  sessionId,
  source
}: AssetScopeInput & {
  source: ReferenceItem;
}) {
  return createLinkAsset({
    projectId,
    sessionId,
    title: source.title,
    url: source.url,
    kind: "paper"
  });
}
